export const add_notification = (count) => ({
  type: 'add_notification',
  payload: count,
});
